export const centsToDecimal = (payment) => {
  return Math.trunc(payment) / 100;
};
